export default "<p>create-user works!</p>\n"